import React from "react";
import _ from "lodash";
import TagCloudContainer from "./../tag-cloud-container";
import { TagCloud } from "react-tagcloud";
import Taxonomy from "./../taxonomy";
import { Button, makeStyles, CircularProgress } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { setPageNumber } from "../../epics/pageNumberEpic";
import TaxonomyData from "../../taxonomyData.json";
import { addKeyphrases } from "../../epics/canvasEpics";

const useS3ContainerStyles = makeStyles(
  {
    s3container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      height: "95%",
      alignItems: (props) => (props.sizeBreak ? "" : "center"),
      width: "99%",
    },

    s3CardHolder: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-around",
      height: "85%",
    },

    taxContainer: {
      display: "flex",
      flexWrap: "wrap",
      overflow: "auto",
      maxWidth: "45%",
      justifyContent: "left",
      marginTop: "8px",
    },

    progressContainer: {
      display: "flex",
      width: "80%",
      alignItems: "center",
      justifyContent: "center",
      padding: 20,
    },

    tagCloud: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "center",
    },
  },
  { name: "S3ContainerStyles" },
);

export default function Step3Container(props) {
  const { content, needResize } = props;
  const dispatch = useDispatch();
  const classes = useS3ContainerStyles({ sizeBreak: needResize[0] });

  const taxonomyColors = useSelector((state) => state.taxonomyGroupColors);
  const taxonomyGroups = useSelector((state) => state.taxonomyGroups);
  const checkedCardStepOne = useSelector((state) => state.checkedCardStepOne);
  const checkedCardStepTwo = useSelector((state) => state.checkedCardStepTwo);
  const groups = useSelector((state) => state.group, _.isEqual);
  const taxonomyTagsAndPositions = useSelector((state) => state.taxonomyTagsAndPositions, _.isEqual);

  const tagsAndPositions = React.useMemo(
    () => taxonomyTagsAndPositions[checkedCardStepOne + " " + checkedCardStepTwo],
    [taxonomyTagsAndPositions, checkedCardStepOne, checkedCardStepTwo],
  );
  const group = React.useMemo(
    () => groups[checkedCardStepOne + " " + checkedCardStepTwo],
    [groups, checkedCardStepOne, checkedCardStepTwo],
  );

  return (
    // container for call to action button
    <div className={classes.s3container}>
      {/* container for tagcloud and taxonomy */}
      <div className={classes.s3CardHolder}>
        {/* tag cloud with container */}
        <div className={classes.taxContainer}>
          <TagCloudContainer needResize={needResize}>
            {!_.isEmpty(taxonomyColors) &&
            !_.isEmpty(taxonomyGroups[checkedCardStepOne + " " + checkedCardStepTwo]) ? (
              <TagCloud
                disableRandomColor={true}
                shuffle={false}
                tags={content[0]}
                onClick={(e, f) => content[1](e, f)}
                minSize={1}
                maxSize={50}
                renderer={(tag) => content[2](tag, classes, needResize[0] || needResize[1])}
                className={classes.tagCloud}
              />
            ) : (
              <div className={classes.progressContainer}>
                <CircularProgress />
              </div>
            )}
          </TagCloudContainer>
        </div>
        {/* taxonomy with container */}
        <div className={classes.taxContainer}>
          <Taxonomy needResize={needResize} />
        </div>
      </div>

      {/* call to action button to leave step */}
      <Button
        disabled={tagsAndPositions === undefined}
        variant="outlined"
        style={{ width: "50%", backgroundColor: "white", margin: "auto" }}
        onClick={() => {
          _.map(TaxonomyData, (taxa, key) =>
            dispatch(
              addKeyphrases(
                taxa,
                _.map(taxa, (taxon) => tagsAndPositions?.[0][_.indexOf(tagsAndPositions?.[1], taxon)]),
                group ? (group[key] ? group[key] : []) : [],
                key,
                checkedCardStepOne + " " + checkedCardStepTwo,
              ),
            ),
          );
          dispatch(setPageNumber(4));
        }}
      >
        Auswahl im 3D Modell anzeigen
      </Button>
    </div>
  );
}
